export default "__VITE_ASSET__BAkye0x___"